import styled from '@emotion/styled'
import { space } from '../utils'
import { Modifiable, Mods } from '../../../styles/primitives/core/mods'
import { SpaceProp } from '../../../styles/primitives/modifiers/size/space'
import { css } from '@emotion/react'

type Props = Mods & SpaceProp & { centered?: true }

const centered = (props: Props) => props.centered && css({ alignItems: 'center', justifyItems: 'center' })

/**
 * Lays out children vertically with space between. Can be nested.
 * https://every-layout.dev/layouts/stack/
 * @space - string
 */
export const Stack = styled.div<Props>`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	${centered}
	gap: ${space};
	${Modifiable}
`
